import { useMemo } from 'react';

import _ from 'lodash';

import { devicesStateService } from '../../../../services/devicesState.service';
import { createApiSlice } from '../../utils/createApiSlice';

const getAllDeviceStateSlice = createApiSlice({
  reducerPath: ['devices', 'state', 'getAllDeviceState'],
  apiFunction: devicesStateService.getAllStateV2,
  getStateUpdatePath: (action) => {
    const growerId = _.get(action, 'payload.apiArguments.0');
    const seasonId = _.get(action, 'payload.apiArguments.1');
    const deviceId = _.get(action, 'payload.apiArguments.2');
    return [growerId, seasonId, deviceId];
  },
  getSelectorPath: (growerId, seasonId, deviceId) => {
    return [growerId, seasonId, deviceId];
  },
  apiArgumentsFn: ({ growerId, seasonId, deviceId }) => [
    growerId,
    seasonId,
    deviceId
  ]
});

const { actions, selectors, useApiSelectors } = getAllDeviceStateSlice;

export const getAllDeviceStateActions = actions;

export const getAllDeviceStateSelectors = {
  ...selectors
};

export const useGetAllDeviceStateSelectors = (growerId, seasonId, deviceId) => {
  const {
    inProgress,
    errorMessage,
    success,
    response: state,
    updatedAt
  } = useApiSelectors(growerId, seasonId, deviceId);

  return useMemo(
    () => ({
      state,
      inProgress,
      errorMessage,
      success,
      updatedAt
    }),
    [errorMessage, inProgress, state, success, updatedAt]
  );
};

export default getAllDeviceStateSlice;
